const supportsCardTilt = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
if (supportsCardTilt) {
  document.addEventListener('pointermove', (event) => {
    const frame = event.target.closest?.('.product-card .product-art');
    if (!frame) return;
    const image = frame.querySelector('img');
    if (!image) return;
    const bounds = frame.getBoundingClientRect();
    const x = (event.clientX - bounds.left) / bounds.width;
    const y = (event.clientY - bounds.top) / bounds.height;
    frame.style.setProperty('--flash-x', `${x * 100}%`);
    frame.style.setProperty('--flash-y', `${y * 100}%`);
    const rotateY = (x - 0.5) * 6;
    const rotateX = (0.5 - y) * 6;
    image.style.transform = `perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(0.94)`;
  });
  document.addEventListener('pointerout', (event) => {
    const frame = event.target.closest?.('.product-card .product-art');
    if (!frame || frame.contains(event.relatedTarget)) return;
    const image = frame.querySelector('img');
    if (image) image.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg) scale(1)';
    frame.style.setProperty('--flash-x', '50%');
    frame.style.setProperty('--flash-y', '50%');
  });
}
const cartDrawerRoot = document.querySelector('#CartDrawerRoot');
const cartDrawer = () => document.querySelector('#CartDrawer');
const openCartDrawer = () => {
  const drawer = cartDrawer();
  const overlay = document.querySelector('.cart-drawer-overlay');
  if (!drawer || !overlay) return;
  drawer.hidden = false;
  drawer.setAttribute('aria-hidden', 'false');
  overlay.hidden = false;
  document.body.classList.add('cart-drawer-open');
  drawer.querySelector('.cart-drawer__close')?.focus();
};
const closeCartDrawer = () => {
  const drawer = cartDrawer();
  const overlay = document.querySelector('.cart-drawer-overlay');
  if (!drawer || !overlay) return;
  drawer.hidden = true;
  drawer.setAttribute('aria-hidden', 'true');
  overlay.hidden = true;
  document.body.classList.remove('cart-drawer-open');
};
const setCartDrawerMessage = (message) => {
  const status = document.querySelector('[data-cart-drawer-message]');
  if (status) status.textContent = message;
};
const refreshCartDrawer = async () => {
  const response = await fetch(window.location.href, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  });
  if (!response.ok) throw new Error('Could not refresh cart');
  const page = new DOMParser().parseFromString(await response.text(), 'text/html');
  const freshRoot = page.querySelector('#CartDrawerRoot');
  const currentRoot = document.querySelector('#CartDrawerRoot');
  if (!freshRoot || !currentRoot) throw new Error('Cart preview is unavailable');
  currentRoot.innerHTML = freshRoot.innerHTML;
  currentRoot.dataset.cartChangeUrl = freshRoot.dataset.cartChangeUrl;
  const freshCount = page.querySelector('[data-cart-count]')?.textContent?.trim() ??
    page.querySelector('[data-drawer-count]')?.textContent?.trim() ?? '0';
  document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = freshCount; });
};
const updateCartLine = async (key, quantity, control) => {
  if (!cartDrawerRoot || !key) return;
  const changeUrl = new URL(cartDrawerRoot.dataset.cartChangeUrl, window.location.origin);
  changeUrl.pathname = `${changeUrl.pathname.replace(/\/$/, '')}.js`;
  if (control) control.disabled = true;
  try {
    const response = await fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error('Could not update cart');
    await refreshCartDrawer();
    openCartDrawer();
  } catch (_) {
    setCartDrawerMessage('We could not update that quantity. Please try again.');
    if (control) control.disabled = false;
  }
};
document.addEventListener('click', (event) => {
  if (event.target.closest('[data-cart-drawer-open]') && cartDrawerRoot) {
    event.preventDefault();
    openCartDrawer();
  }
  if (event.target.closest('[data-cart-drawer-close]')) closeCartDrawer();
  const removeButton = event.target.closest('[data-cart-line-remove]');
  if (removeButton) updateCartLine(removeButton.dataset.lineKey, 0, removeButton);
});
document.addEventListener('change', (event) => {
  const input = event.target.closest('[data-cart-line-quantity]');
  if (!input) return;
  const max = input.dataset.maxQuantity === undefined ? Infinity : Number(input.dataset.maxQuantity);
  const entered = Number(input.value);
  const quantity = Number.isFinite(entered) ? Math.max(0, Math.min(Math.floor(entered), max)) : 0;
  input.value = String(quantity);
  updateCartLine(input.dataset.lineKey, quantity, input);
});
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form || !cartDrawerRoot) return;
  event.preventDefault();
  const button = event.submitter || form.querySelector('[type="submit"]');
  if (button) button.disabled = true;
  let itemWasAdded = false;
  try {
    const addUrl = new URL(form.action, window.location.origin);
    addUrl.pathname = `${addUrl.pathname.replace(/\/$/, '')}.js`;
    const formData = new FormData(form);
    if (!formData.has('quantity')) formData.set('quantity', '1');
    const response = await fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Could not add this card');
    itemWasAdded = true;
    await refreshCartDrawer();
    setCartDrawerMessage('Added to your cart. You can change the quantity here.');
    openCartDrawer();
  } catch (error) {
    openCartDrawer();
    setCartDrawerMessage(itemWasAdded
      ? 'Added to your cart, but the cart preview could not refresh. Please reopen it or view your cart.'
      : error.message || 'Could not add this card. Please try again.');
  } finally {
    if (button?.isConnected) button.disabled = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && cartDrawer() && !cartDrawer().hidden) closeCartDrawer();
});
document.querySelectorAll('[data-cart-form]').forEach((form) => {
  const error = form.querySelector('[data-cart-error]');
  const checkoutButton = form.querySelector('button[name="checkout"]');
  const quantityInputs = [...form.querySelectorAll('input[name="updates[]"]')];
  const constrainQuantity = (input, commit = false) => {
    if (input.value === '' && !commit) return;
    const entered = Number(input.value);
    let quantity = Number.isFinite(entered) ? Math.max(0, Math.floor(entered)) : 0;
    if (input.dataset.maxQuantity !== undefined) {
      quantity = Math.min(quantity, Number(input.dataset.maxQuantity));
    }
    input.value = String(quantity);
  };
  quantityInputs.forEach((input) => {
    input.addEventListener('input', () => constrainQuantity(input));
    input.addEventListener('change', () => constrainQuantity(input, true));
  });
  form.addEventListener('submit', async (event) => {
    quantityInputs.forEach((input) => constrainQuantity(input, true));
    if (event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    error.hidden = true;
    checkoutButton.disabled = true;
    const updates = [...form.querySelectorAll('input[name="updates[]"]')]
      .map((input) => Math.max(0, Number.parseInt(input.value, 10) || 0));
    const cartUrl = new URL(form.action, window.location.origin);
    const path = cartUrl.pathname.replace(/\/$/, '');
    try {
      const response = await fetch(`${cartUrl.origin}${path}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      const checkoutUrl = `${cartUrl.origin}${path.replace(/\/cart$/, '')}/checkout`;
      window.location.assign(cart.item_count === 0 ? cartUrl.href : checkoutUrl);
    } catch (_) {
      error.hidden = false;
      checkoutButton.disabled = false;
    }
  });
});
document.querySelectorAll('.featured-products[data-price-source]').forEach(async (section) => {
  const grid = section.querySelector('.product-grid');
  if (!grid) return;
  try {
    const response = await fetch(section.dataset.priceSource, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) return;
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const cards = [...page.querySelectorAll('.collection-page .product-card')]
      .filter((card) => card.querySelector('.add-button'))
      .slice(0, 8);
    if (cards.length) grid.replaceChildren(...cards.map((card) => document.importNode(card, true)));
  } catch (_) {
    // Keep the server-rendered fallback cards if Shopify's sorted collection can't be loaded.
  }
});

document.querySelectorAll('[data-inventory-search]').forEach((input) => {
  const section = input.closest('.collection-page');
  const grid = section?.querySelector('[data-collection-products]');
  const status = section?.querySelector('.filter-status');
  const pagination = section?.querySelector('.pagination');
  if (!grid || !status) return;

  const initialCards = [...grid.querySelectorAll('[data-filter-product]')];
  let allCards = null;
  let loadPromise = null;
  let requestId = 0;

  const loadCollectionCards = async () => {
    if (allCards) return allCards;
    if (loadPromise) return loadPromise;
    loadPromise = (async () => {
      const pageCount = Number(grid.dataset.pageCount) || 1;
      const pages = [];
      const currentPage = Number(new URL(window.location.href).searchParams.get('page')) || 1;
      for (let page = 1; page <= pageCount; page += 1) {
        if (page === currentPage) { pages.push({ current: true }); continue; }
        const url = new URL(window.location.href);
        url.searchParams.set('page', String(page));
        pages.push({ url: url.href });
      }
      const pagesOfCards = [];
      for (let index = 0; index < pages.length; index += 4) {
        const batch = await Promise.all(pages.slice(index, index + 4).map(async (page) => {
          if (page.current) return initialCards;
          try {
            const response = await fetch(page.url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!response.ok) return [];
            const html = await response.text();
            return [...new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-collection-products] [data-filter-product]')];
          } catch (_) { return []; }
        }));
        pagesOfCards.push(...batch);
      }
      allCards = pagesOfCards.flat();
      return allCards;
    })();
    try { return await loadPromise; } finally { loadPromise = null; }
  };

  input.addEventListener('input', async () => {
    const query = input.value.trim().toLocaleLowerCase();
    const currentRequest = ++requestId;
    if (!query) {
      grid.replaceChildren(...initialCards);
      status.textContent = `Showing ${initialCards.length} products`;
      if (pagination) pagination.hidden = false;
      return;
    }

    status.textContent = 'Searching this collection…';
    if (pagination) pagination.hidden = true;
    const cards = await loadCollectionCards();
    if (currentRequest !== requestId) return;
    const matches = cards.filter((card) => (card.dataset.name || '').includes(query));
    grid.replaceChildren(...matches);
    status.textContent = matches.length ? `${matches.length} matching ${matches.length === 1 ? 'card' : 'cards'}` : 'No cards found. Try another name.';
  });
});

document.querySelectorAll('[data-collection-sort]').forEach((select) => {
  select.addEventListener('change', () => select.form?.requestSubmit());
});
